/* eslint-disable no-unused-vars */
import platform from "platform";
import { v4 as uuidv4 } from "uuid";

export const ANALYTICS_EVENT_TYPES = {
  PAGE_LOAD: "PAGE_LOAD",
  HEARTBEAT: "HEARTBEAT",
  BUTTON_CLICK: "BUTTON_CLICK",
  PAGE_READY: "PAGE_READY",
};

const mod = () => {
  let uuid = "";
  let productId = "";
  let lastInteractionTime = Date.now();
  const getParentUrl = () => {
    const url =
      window.location !== window.parent.location
        ? document.referrer
        : document.location.href;
    return url;
  };
  const getPlatform = () => {
    const platformDetails = {
      platformOsFamily: platform?.os?.family,
      platformOsVersion: platform?.os?.version,
      platformProduct: platform?.product,
      platformName: platform?.name,
      platformDescription: platform?.description,
      platformUaString: platform?.ua,
      platformType:
        platform?.os?.family.toLowerCase() === "ios" ||
        platform?.os?.family.toLowerCase() === "android"
          ? "Mobile"
          : "Desktop",
    };
    return platformDetails;
  };

  const getTimeStamp = () => {
    // return new Date(
    //   `${new Date().toString().split("GMT")[0]} UTC`
    // ).toISOString();
    return Date.now();
  };

  const sendDataToServer = (Data) => {
    fetch(
      "https://b87xaby7eg.execute-api.ap-south-1.amazonaws.com/prod_luminosity/luminosity/event",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Data,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => console.info("finalres", JSON.stringify(Data)));
  };

  const initializeAnalytics = (isRemoteAnalytics, experienceId, mode) => {
    if (uuid === "") {
      uuid = uuidv4();
      productId = experienceId;
    }
    if (!window.location.href.includes("localhost")) {
      const params = new URLSearchParams(window.location.search);
      const skuid =
        params.get("skuId") || params.get("skuid") || params.get("sku_id");
      sendDataToServer({
        tenantId: productId,
        eventTimestamp: getTimeStamp(),
        source: "Orion",
        actionCategory: "Page"?.toUpperCase(),
        action: "Pageview",
        category: "Event",
        ...getPlatform(),
        skuId: skuid,
        mode,
        nonInteraction: true,
        sessionId: uuid,
        page: window.location.pathname + window.location.search,
        referrer: getParentUrl(),
      });
      lastInteractionTime = Date.now();
    } else {
      console.log("Send No Data");
    }
  };

  const sendAnalyticsEvent = (
    eventType,
    data = {},
    options = {},
    other = {}
  ) => {
    const params = new URLSearchParams(window.location.search);
    const skuid =
      params.get("skuId") || params.get("skuid") || params.get("sku_id");
    sendDataToServer({
      tenantId: productId,
      eventTimestamp: getTimeStamp(),
      source: "Orion",
      actionCategory: eventType?.toUpperCase(),
      action: data.action,
      category: "Event",
      ...other,
      ...getPlatform(),
      skuId: skuid,
      nonInteraction: options.nonInteraction || true,
      sessionId: uuid,
      page: window.location.pathname + window.location.search,
    });
    if (options.nonInteraction === true) lastInteractionTime = Date.now();
  };

  return {
    sendAnalyticsEvent,
    initializeAnalytics,
    getLastInteractionTime: () => lastInteractionTime,
  };
};

const AvataarTracker = mod();
export default AvataarTracker;
